import { CustomBottomBar, MinimalStepper, PdfViewer } from '@components';
import { Typography, Container, Button, Icon, Checkbox, Modal } from '@design-system';

import './ToolsPage.scss';
import { useToolsPageVM } from './useToolsPageVM';
import { LiaArrowLeftSolid } from 'react-icons/lia';

export const ToolsPage: React.FC = () => {
    const {
        handleSetHasSeenAllPages,
        computedStepperSteps,
        handleNext,
        handlePrev,
        canGoBack,
        currentStep,
        steps,
        isChecked,
        setIsChecked,
        isPpspsModalOpen,
        handleOpenPpspsModal,
        handleClosePpspsModal,
        ppsps
    } = useToolsPageVM();

    return (
        <div className="tools-page">
            <Container className="tools-header" radius="none" column>
                <Typography intrinsic="h2" className="mb-large-spacing">
                    {computedStepperSteps[currentStep].label}
                </Typography>
                <MinimalStepper steps={computedStepperSteps} />
            </Container>

            <Container>
                {steps.map((step, index) => {
                    const isVisible = index === currentStep;
                    if (!isVisible) return null;
                    if (step.label === 'Le PPSPS') {
                        return (
                            <div key={step.label}>
                                <Container bordered="grey" className="ppsps-container">
                                    <Typography intrinsic="h3" defaultSpacing>
                                        Le PPSPS
                                    </Typography>
                                    <Typography intrinsic="p" className="mb-medium-spacing">
                                        Une version papier du PPSPS est disponible sur le chantier ou directement sur l'application.
                                    </Typography>
                                    <Checkbox
                                        label="Je certifie l'avoir consulté, en avoir compris le contenu, et m'engage à respecter les consignes de sécurité qui y sont définies"
                                        checked={isChecked}
                                        onChange={() => setIsChecked(!isChecked)}
                                    />
                                    <Button
                                        color="blue"
                                        variant="secondary"
                                        size="small"
                                        onClick={handleOpenPpspsModal}
                                        className="mt-medium-spacing"
                                    >
                                        <Typography intrinsic="h4">Consulter le PPSPS du chantier</Typography>
                                    </Button>
                                </Container>
                            </div>
                        );
                    }
                    return <PdfViewer key={step.label} file={step.pdf} setHasSeenAllPages={handleSetHasSeenAllPages} />;
                })}
            </Container>

            <Modal open={isPpspsModalOpen} setClose={handleClosePpspsModal} title="PPSPS du chantier">
                {ppsps && <PdfViewer file={ppsps.pdf_url} setHasSeenAllPages={() => {}} bottomBarPagination />}
            </Modal>

            <CustomBottomBar>
                <Button
                    color="marine"
                    variant="secondary"
                    onClick={handlePrev}
                    disabled={!canGoBack}
                    className="sm-bottom-bar-button mr-small-spacing"
                >
                    <Icon className="arrow-left" color="grey" icon={<LiaArrowLeftSolid />} size={30} />
                </Button>
                <Button
                    variant="primary"
                    color="marine"
                    size="fullwidth"
                    onClick={handleNext}
                    disabled={!steps[currentStep].hasSeenAllPages}
                    className="next-button"
                >
                    <Typography intrinsic="h4">Suivant</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
